import {Form, Input, Row, Col, InputNumber} from 'antd';
import React, {useContext, useEffect} from 'react';
import WangEditor from "../common/WangEditor";
import {sideMenuContext} from "../../../router/IndexRouter";
import AddFormComponent from "../common/AddFormComponent";
import EditFormComponent from "../common/EditFormComponent";
import {Arguments} from "../common/Arguments";
import SaveButtonComponent from "../common/SaveButtonComponent";
import {validateEditorContent, validateWhiteSpace} from "../common/ValidateWhiteSpace";


const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};
const tailLayout = {
    wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef()

const AddBaseRecognition = () => {
    // 获取 WangEditor 中的内容
    const {editorContent} = useContext(sideMenuContext);
    const currentUrl = window.location.href;
    const apiList = [Arguments.host + "/society_organization/base/branch/api!addBaseRecognition.do"];

    useEffect(() => {
        formRef.current.setFieldsValue({
            commendMemo: editorContent
        })
    }, [editorContent])

    return (currentUrl.endsWith("add") ? <AddFormComponent UserForm={BaseRecognitionForm} url={apiList}/> :
        <EditFormComponent UserForm={BaseRecognitionForm} url={apiList}/>)
}

const BaseRecognitionForm = ({onFinish, initialValues}) => {
    const [form] = Form.useForm();

    return (
        <Form
            {...layout}
            form={form}
            onFinish={onFinish}
            initialValues={initialValues}
            style={{maxWidth: 1200, marginLeft: 40}}
            ref={formRef}
        >
            <Row align="top">
                <Col span={12}>
                    <Form.Item name="commendYear" label="表彰年度"
                               rules={[{required: true, message: '内容不能为空'}]}>
                        <InputNumber min={0} style={{width: 150}}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="commendName" label="表彰名称"
                               rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="commendContent" label="说明" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="commendMemo" label="详细信息" rules={[{required: true, validator: validateEditorContent}]}>
                        <WangEditor defaultValue={initialValues?.commendMemo}/>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item {...tailLayout}>
                <SaveButtonComponent/>
            </Form.Item>
        </Form>
    )
}

export default AddBaseRecognition;